module.exports = __webpack_public_path__ + "img/GetItOnGooglePlay_Badge_Web_color_Spanish.7e9d3e2b.png";